
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[transversal]",
      function () {
        return require("private-next-pages/[transversal].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[transversal]"])
      });
    }
  